import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useState, useEffect } from "react";

const useLoadSPpositions = (url, reloadPoslistdata) => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  // States
  const [listdata, setListdata] = useState([]);
  useEffect(() => {
    const controller = new AbortController();
    const getSPPositionsList = async () => {
      try {
        const response = await axiosPrivate.get(`/api/qs/${url}`);
        if (response.data.message !== "No positions exist.") {
          setListdata(response.data);
        }
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getSPPositionsList();
    return () => controller.abort();
  }, [reloadPoslistdata]);

  return listdata;
};

export default useLoadSPpositions;
